<template>
  <transition name="fade">
    <div class="modal" v-show="visible">
      <div class="modal__wrap">
        <div class="modal__header">
          <h2 class="modal__title">{{ opts.title }}</h2>
        </div>
        <div class="modal__body">
          <p v-html="opts.text"></p>

          <loader v-show="opts.showLoader" />

          <div class="text-center">
            <button class="btn btn--inline btn--white" @click="cancel()" v-show="opts.cancelButton">{{ opts.cancelButtonText }}</button>
            <button class="btn btn--inline btn--purple" @click="ok()" v-show="opts.okButton" ref="ok">{{ opts.okButtonText }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import Loader from './Loader.vue'

const defaultOptions = {
  title: '',
  text: '',
  cancelButtonText: 'ยกเลิก',
  okButtonText: 'ตกลง',
  cancelButton: false,
  okButton: true,
  showLoader: false
}

export default {
  components: {Loader},
  name: 'VueModal',
  data () {
    return {
      visible: false,
      opts: Object.assign({}, defaultOptions)
    }
  },
  methods: {
    show (options) {
      this.opts = Object.assign({}, defaultOptions, options)
      this.visible = true
      if (this.$refs.ok) {
        setTimeout(() => this.$refs.ok.focus(), 100)
      }
    },
    hide () {
      this.visible = false
    },
    ok () {
      this.opts['ok'] && this.opts['ok'].call(this)
      this.visible = false
    },
    cancel () {
      this.opts['cancel'] && this.opts['cancel'].call(this)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal {
    z-index: 999;
    &__title {
      font-size: 1.3em
    }
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?5fdde8f8